import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
 
export const GetSpecialityDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Speciality/GetDetail?` + params, null);

export const GetSpecialityList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Speciality/GetList?` + params, null);
 
export const GetSystemList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Speciality/GetListSystemList?` + params, null);

export const CreateSpeciality = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Speciality/Create`, data);

export const UpdateSpeciality = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Speciality/Update`, data);    

export const DeleteSpeciality = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Speciality/Delete`, data);

export const GetAllowedSystemsForSpeciality = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Speciality/GetAllowedSystems?` + params, null);
 
